import { IPageInfo, ITableRowData } from './common.model';
import { IUser } from './user.model';

export enum FormType {
  MyForms = 'myForms',
  TeamForms = 'teamForms',
  TeamSubmission = 'teamSubmission',
}

export interface IFormColumn {
  id?: string;
  label: string;
  columnName: string;
  columnDatatype: string;
  required: boolean;
  options?: { label: string; value: string }[];
  sequence: number;
  placeholder?: string;
  helpText?: string;
  section?: string;
  value?: string | null;
}

export interface IFormSection {
  id?: string;
  name: string;
  sequence: number;
  columns: IFormColumn[];
}

export interface IFormData {
  id: string;
  formId?: string;
  name?: string;
  columns?: IFormColumn[];
  data?: IFormColumn[];
  // index: string;
  description?: string;
  totalColumns?: number;
  status?:
    | 'draft'
    | 'published'
    | 'archived'
    | string
    | number
    | boolean
    | null;
  sections: IFormSection[];
  createdAt?: string | null;
  updatedAt?: string | null;
  submittedAt?: string | null;
  submittedBy?: IUser;
  designationIds?: string[];
  form?: {
    name: string;
    id: string;
  };
  managerRating?: number;
  managerRemark?: string;
  managerId?: string;
}

export interface IFormRowData extends IFormData, ITableRowData {
  index?: number | string;
  formStatus?: React.ReactNode;
  formCreatedAt?: string;
  submittedByName?: string;
}

export interface IFormPageStates extends IPageInfo {
  count: number;
  searchQuery: string;
  tableLoader: boolean;
  orderBy?: string;
}

export interface IFormResponse {
  status: boolean;
  message: string;
  data: {
    officeForm: IFormData[];
    pageInfo: IPageInfo;
  };
}

export interface IFormReviewAndRatingResponse {
  status: boolean;
  message: string;
  data: {
    managerRemark: string;
    managerRating: number;
  };
}

export interface IFormViewResponse {
  status: boolean;
  message: string;
  data: IFormData;
}

export type IFormSubmissionValue =
  | string
  | number
  | boolean
  | File
  | string[]
  | null;

export interface IFormSubmissionField {
  id: string;
  value: IFormSubmissionValue;
}

export interface IFormSubmissionPayload {
  formId: string;
  status: string;
  managerId?: string;
  data: IFormSubmissionField[];
}

export type InputType =
  | 'text'
  | 'textarea'
  | 'number'
  | 'email'
  | 'phone'
  | 'date'
  | 'select'
  | 'radio'
  | 'checkbox'
  | 'file'
  | 'image'
  | 'video'
  | 'audio'
  | 'url'
  | 'password'
  | 'hidden'
  | 'submit'
  | 'reset'
  | 'button'
  | 'color'
  | 'range'
  | 'month'
  | 'week'
  | 'datetime-local'
  | 'time'
  | 'search'
  | 'tel'
  | 'url';
